import React, {useEffect, useState} from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  TouchableHighlight,
  ScrollView,
} from 'react-native';
import {useSelector} from 'react-redux';
import {Color, globalFontStyle, globalStyle} from '../../../assets';
import CommonModal from '../../../commonComponents/commonModal';
import FAQ from '../../../commonComponents/FAQ';
import RupeeVal from '../../../commonComponents/RupeeVal';
import {WALLET_OPTION, WALLET_TRANSACTION_STATUS} from '../wallet.constant';
import WalletLastTxnStatus from './WalletLastTxnStatus';
import {isMobile, trackMoengageEvent} from '../../../utils/commonMethods';
import Colors from '../../../assets/Color/Colors';
import {countryRegion} from '../../../utils/commonMethods';
import {INDIA} from '../../../utils/constants';
import HomeBanners from '../../home/childComponents/homeBanners';
import {
  add_money,
  coin,
  help,
  info,
  smile_coin,
  withdraw_money,
} from '../../../utils/images';
import { ethers } from 'ethers';
import { magic, network, contractAddress, getScwAddress } from '../../../lib/magic';
import { Icon } from '@iconify/react';

import FastImage from '../../../common/FastImage';
import Width from '../../../assets/Width';
import Tooltip from 'react-native-walkthrough-tooltip';
import FormTextLabel from '../../../commonComponents/FormTextLabel';
import {useFocusEffect} from '@react-navigation/native';
import PartnerWalletModal from './PartnerWalletModal';
import {
  globalConfigurableData,
  globalConst,
  GlobalScreens,
  partnerMap,
} from '../../../utils/globalConstant';
import {Button} from '../../../components/core/Button';
import TransactionDrawer from '../../../commonComponents/TransactionDrawer';

const WalletSummary = ({
  navigation,
  conversionData,
  showFaq,
  setShowFaq,
  conversionMessage,
}) => {
  const [toolTipVisible, setToolTipVisible] = useState(false);
  const [showPartnerModal, setShowPartnerModal] = useState(false);
  const [showBreakupModal, setShowBreakupModal] = useState(false);
  const [showTransactionDrawer, setShowTransactionDrawer] = useState(false);
  const [usdtBalance, setUsdtBalance] = useState('0');
  const [usdtSymbol, setUsdtSymbol] = useState('');

  let userInfo = useSelector(({profile}) => profile.profileData);
  
  // Calculate combined real money balance
  const realMoneyBalance = Math.floor(
    (userInfo?.coinsb || 0) + 
    (userInfo?.coinsd || 0) + 
    (userInfo?.coinsw || 0)
  );
  
  const playMoneyBalance = userInfo?.coinsp >= 0 ? Math.floor(userInfo?.coinsp) : '-';
  const bonusBalance = userInfo?.bonus >= 0 ? Math.floor(userInfo?.bonus) : '-';

  const bonusAmount = userInfo?.coinsb;
  const isShowHoldAmount = userInfo?.withdrawConfig?.isShowHoldAmount;
  const holdAmount = userInfo?.holdAmount;
  let currency = userInfo?.currency;
  const globalConfigData = useSelector(
    state => state.utilReducer.globalConfigData,
  );

  useFocusEffect(
    React.useCallback(() => {
      trackMoengageEvent('Clicked on Wallet', {
        AvailableFunds: parseFloat(realMoneyBalance).toFixed(0),
        BonusAmount: bonusAmount,
        Earnings: playMoneyBalance,
      });
    }, []),
  );

  let region = userInfo?.region_code ?? 'INDIA';

  const onBtnPress = redirectionRoute => {
    if (GlobalScreens.Wallet.partnerPopUp) {
      setShowPartnerModal(true);
    } else {
      if (redirectionRoute === 'Redeem') {
        navigation.navigate('RewardsStack', {screen: 'Rewards'});
        return;
      }
      if (redirectionRoute === 'Add Funds') {
        if (
          !userInfo?.isProfileComplete &&
          userInfo?.isDepositProfileMandatory
        ) {
          navigation.navigate('Profile');
          return;
        }
        trackMoengageEvent('Clicked on Add Funds');
        navigation.navigate('WalletStack', {screen: 'WalletAdd'});
      } else if (redirectionRoute === 'Withdraw') {
        if (!userInfo?.isProfileComplete) {
          navigation.navigate('Profile');
          return;
        }
        trackMoengageEvent('Clicked on Withdraw');
        navigation.navigate('WalletStack', {screen: 'WalletWithdraw'});
      }
    }
  };

  const handleBreakupClick = () => {
    if (isMobile()) {
      setShowBreakupModal(true);
    } else {
      setShowTransactionDrawer(true);
    }
  };

  let walletMap = [
    {
      title: 'Real Money',
      balance: realMoneyBalance,
      imgText: 'Add Funds',
      showWithdraw: true
    }
  ];
  
  if (globalConst.partnerId === 1) {
    walletMap.push({
      title: 'Play Money',
      balance: playMoneyBalance,
      imgText: 'Redeem',
      img: smile_coin(),
    });
  }

  useEffect(() => {
    if (region !== INDIA) {
      fetchUsdtBalance();
    }
  }, []);

  const fetchUsdtBalance = async () => {
    try {
      const address = await getScwAddress(network);
      const provider = new ethers.JsonRpcProvider(network.rpcUrl);
      const abi = [
        "function balanceOf(address owner) view returns (uint256)",
        "function decimals() view returns (uint8)",
        "function symbol() view returns (string)"
      ];
      const contract = new ethers.Contract(contractAddress, abi, provider);
      
      const [balance, decimals, symbol] = await Promise.all([
        contract.balanceOf(address),
        contract.decimals(),
        contract.symbol()
      ]);

      const formattedBalance = ethers.formatUnits(balance, decimals);
      console.log("[DEBUG] SCW Address:", address);
      console.log("[DEBUG] Contract Address:", contractAddress);
      console.log("[DEBUG] Network URL:", network.rpcUrl);
      console.log("[DEBUG] Raw Balance:", balance.toString());
      console.log("[DEBUG] Decimals:", decimals);
      console.log("[DEBUG] Symbol:", symbol);
      console.log("[DEBUG] Formatted Balance:", formattedBalance);
      setUsdtBalance(formattedBalance);
      setUsdtSymbol(symbol);
    } catch (error) {
      console.error("Error fetching USDT balance:", error);
      setUsdtBalance('0');
      setUsdtSymbol('USDT');
    }
  };

  return (
    <>
      <TransactionDrawer
        open={showTransactionDrawer}
        onClose={() => setShowTransactionDrawer(false)}
        breakupData={{
          depositBalance: Math.floor(userInfo?.coinsd || 0),
          promoBalance: Math.floor(userInfo?.coinsb || 0),
          winningBalance: Math.floor(userInfo?.coinsw || 0)
        }}
        showBreakup={true}
      />
      <CommonModal
        onModalCallBack={() => setShowFaq(false)}
        showModal={showFaq}
        animationType={'slide'}
        customModalStyle={[
          globalStyle.modalView,
          isMobile()
            ? {}
            : {
                alignItems: 'stretch',
                top: 0,
                right: 0,
                width: Width.width / 3,
              },
        ]}>
        <ScrollView
          style={{
            backgroundColor: globalConfigurableData.globalThemeColor,
            maxHeight: Width.height * 0.7,
          }}
          showsVerticalScrollIndicator={true}>
          <TouchableOpacity>
            <FAQ />
          </TouchableOpacity>
        </ScrollView>
      </CommonModal>
      <CommonModal
        onModalCallBack={() => setShowPartnerModal(false)}
        showModal={showPartnerModal}
        animationType={'fade'}
        customModalStyle={[
          globalStyle.modalView,
          isMobile()
            ? {}
            : {
                alignItems: 'stretch',
                top: 0,
                right: 0,
                width: Width.width / 3,
              },
        ]}>
        <PartnerWalletModal
          onBtnClick={() => {
            setTimeout(() => {
              setShowPartnerModal(false);
            }, globalConst?.buttonTimer);
          }}
          conversionMessage={conversionMessage}
        />
      </CommonModal>
      <CommonModal
        onModalCallBack={() => setShowBreakupModal(false)}
        showModal={showBreakupModal}
        animationType={'slide'}
        customModalStyle={[
          globalStyle.modalView,
          isMobile()
            ? {}
            : {
                alignItems: 'stretch',
                position: 'absolute',
                top: 0,
                right: 0,
                width: Width.width / 3,
              },
        ]}>
        <View style={styles.breakupModalContent}>
          <Text style={styles.breakupModalTitle}>Amount Breakup</Text>
          <Text style={styles.breakupModalSubtitle}>Here's your real money balance summary</Text>
          
          <View style={styles.breakupTable}>
            <View style={[styles.breakupRow, styles.breakupRowFirst]}>
              <Text style={styles.breakupLabel}>Deposit Balance</Text>
              <RupeeVal
                customStyle={styles.breakupValue}
                rupeeVal={Math.floor(userInfo?.coinsd || 0)}
                isZeroCheck={true}
              />
            </View>
            <View style={styles.breakupRow}>
              <Text style={styles.breakupLabel}>Promo Balance</Text>
              <RupeeVal
                customStyle={styles.breakupValue}
                rupeeVal={Math.floor(userInfo?.coinsb || 0)}
                isZeroCheck={true}
              />
            </View>
            <View style={[styles.breakupRow, styles.breakupRowLast]}>
              <Text style={styles.breakupLabel}>Winning Balance</Text>
              <RupeeVal
                customStyle={styles.breakupValue}
                rupeeVal={Math.floor(userInfo?.coinsw || 0)}
                isZeroCheck={true}
              />
            </View>
          </View>
        </View>
      </CommonModal>

      <View style={[styles.walletDetailBox, isMobile() && styles.walletDetailBoxMobile]}>
        {isMobile() ? (
          <View style={styles.gridContainer}>
            <View style={styles.gridRow}>
              {region === INDIA ? (
                // Combined card layout for Indian users
                <View style={[styles.walletCardMobile, styles.fullWidthCard]}>
                  {/* Real Money Section */}
                  <View style={{
                    paddingVertical: 12,
                    paddingHorizontal: 16,
                  }}>
                    <View style={{flexDirection: 'row'}}>
                      <FormTextLabel
                        labelStyles={styles.creditAvaialableTxt}
                        label="Real Money"
                      />
                    </View>
                    <View style={{
                      flexDirection: 'row',
                      alignItems: 'center',
                    }}>
                      <RupeeVal
                        customStyle={styles.creditsAmt}
                        rupeeVal={realMoneyBalance}
                        isZeroCheck={true}
                      />
                    </View>
                    <View style={styles.withdrawableContainer}>
                      <Text style={styles.withdrawableText}>
                        {Math.floor(userInfo?.coinsw || 0)} withdrawable
                      </Text>
                      <TouchableOpacity 
                        onPress={handleBreakupClick}
                        style={styles.whyButton}
                      >
                        <Text style={styles.whyText}>Why?</Text>
                      </TouchableOpacity>
                    </View>
                  </View>

                  {globalConst.partnerId === 1 && (
                    <>
                      <View style={styles.divider} />
                      {/* Play Money Section */}
                      <View style={styles.playMoneyWrapper}>
                        <View style={styles.playMoneyContainer}>
                          <FormTextLabel
                            labelStyles={styles.creditAvaialableTxt}
                            label="Play Money"
                          />
                          <View style={{flexDirection: 'row', alignItems: 'center'}}>
                            {smile_coin() && (
                              <FastImage
                                style={{width: 20, height: 20, marginRight: 8}}
                                source={smile_coin()}
                              />
                            )}
                            <RupeeVal
                              customStyle={styles.creditsAmt}
                              rupeeVal={playMoneyBalance}
                              isZeroCheck={true}
                            />
                          </View>
                        </View>
                        {userInfo?.luckyCoins?.note_string && (
                          <View style={styles.lcBlock}>
                            <Text style={globalFontStyle.appFontSubHeading}>
                              Note -
                              <Text style={globalFontStyle.appFontBody}>
                                {' ' + userInfo?.luckyCoins?.note_string}
                              </Text>
                            </Text>
                          </View>
                        )}
                      </View>
                    </>
                  )}
                </View>
              ) : (
                // Original layout for non-Indian users
                <>
                  <View
                    style={[
                      styles.walletCardMobile,
                      {flex: 1}
                    ]}>
                    <View style={{
                      paddingVertical: 12,
                      paddingHorizontal: 16,
                    }}>
                      <View style={{flexDirection: 'row'}}>
                        <FormTextLabel
                          labelStyles={styles.creditAvaialableTxt}
                          label="Real Money"
                        />
                      </View>
                      <View style={{
                        flexDirection: 'row',
                        alignItems: 'center',
                      }}>
                        <RupeeVal
                          customStyle={styles.creditsAmt}
                          rupeeVal={realMoneyBalance}
                          isZeroCheck={true}
                        />
                      </View>
                      <View style={styles.withdrawableContainer}>
                        <Text style={styles.withdrawableText}>
                          {Math.floor(userInfo?.coinsw || 0)} withdrawable
                        </Text>
                        <TouchableOpacity 
                          onPress={handleBreakupClick}
                          style={styles.whyButton}
                        >
                          <Text style={styles.whyText}>Why?</Text>
                        </TouchableOpacity>
                      </View>
                    </View>
                  </View>

                  {userInfo?.withdrawConfig?.pg?.some(pg => pg.value?.includes('magiclink')) && (
                    <View style={[
                      styles.walletCardMobile,
                      {flex: 1}
                    ]}>
                      <View style={{
                        paddingVertical: 12,
                        paddingHorizontal: 16,
                      }}>
                        <View style={{flexDirection: 'row'}}>
                          <FormTextLabel
                            labelStyles={styles.creditAvaialableTxt}
                            label="USDT Balance"
                          />
                        </View>
                        <View style={{
                          flexDirection: 'row',
                          alignItems: 'center',
                        }}>
                          <Text style={styles.creditsAmt}>
                            {parseFloat(usdtBalance).toFixed(2)} {usdtSymbol}
                          </Text>
                        </View>
                        <View style={styles.withdrawableContainer}>
                          <Text style={styles.withdrawableText}>
                            You can convert your USDT into credits
                          </Text>
                        </View>
                      </View>
                    </View>
                  )}
                </>
              )}
            </View>

            {/* Remove duplicate Play Money card */}
            {region !== INDIA && globalConst.partnerId === 1 && (
              <View style={[
                styles.walletCardMobile,
                styles.fullWidthCard
              ]}>
                <View style={styles.playMoneyWrapper}>
                  <View style={styles.playMoneyContainer}>
                    <FormTextLabel
                      labelStyles={styles.creditAvaialableTxt}
                      label="Play Money"
                    />
                    <View style={{flexDirection: 'row', alignItems: 'center'}}>
                      {smile_coin() && (
                        <FastImage
                          style={{width: 20, height: 20, marginRight: 8}}
                          source={smile_coin()}
                        />
                      )}
                      <RupeeVal
                        customStyle={styles.creditsAmt}
                        rupeeVal={playMoneyBalance}
                        isZeroCheck={true}
                      />
                    </View>
                  </View>
                  {userInfo?.luckyCoins?.note_string && (
                    <View style={styles.lcBlock}>
                      <Text style={globalFontStyle.appFontSubHeading}>
                        Note -
                        <Text style={globalFontStyle.appFontBody}>
                          {' ' + userInfo?.luckyCoins?.note_string}
                        </Text>
                      </Text>
                    </View>
                  )}
                </View>
              </View>
            )}
          </View>
        ) : (
          // Desktop view remains unchanged
          <>
            {walletMap.map((item, i) => {
              const isShowBtn = !isMobile() && (item?.imgText === 'Redeem' ? false : true);
              return (
                <View
                  key={i}
                  style={[
                    styles.walletContainer,
                    i !== walletMap.length - 1 ? {borderRightWidth: 0.75} : null,
                    {flex: 1},
                  ]}>
                  <View
                    style={{
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      paddingVertical: 12,
                      paddingHorizontal: 16,
                      flex: 1,
                    }}>
                    <View style={{flex: 1}}>
                      <View>
                        <View style={{flexDirection: 'row'}}>
                          <FormTextLabel
                            labelStyles={styles.creditAvaialableTxt}
                            label={item?.title}
                          />
                        </View>
                        <View
                          style={{
                            flexDirection: 'row',
                            alignItems: 'center',
                          }}>
                          {item?.img && (
                            <FastImage
                              style={{width: 20, height: 20, marginRight: 5}}
                              source={item.img}
                            />
                          )}
                          <RupeeVal
                            customStyle={styles.creditsAmt}
                            rupeeVal={item?.balance}
                            isZeroCheck={true}
                          />
                        </View>
                        {item?.title === 'Real Money' && (
                          <View style={styles.withdrawableContainer}>
                            <Text style={styles.withdrawableText}>
                              {userInfo?.coinsw || 0} withdrawable
                            </Text>
                            <TouchableOpacity 
                              onPress={handleBreakupClick}
                              style={styles.whyButton}
                            >
                              <Text style={styles.whyText}>Why?</Text>
                            </TouchableOpacity>
                          </View>
                        )}
                      </View>
                    </View>
                    {isShowBtn && (
                      <View style={{flexDirection: 'row'}}>
                        <Button
                          variant="primary"
                          onPress={() => onBtnPress('Add Funds')}
                          style={{
                            height: 40,
                            width: 120,
                            display: 'none'  // Hide Add Funds button on desktop
                          }}
                        >
                          Add Funds
                        </Button>
                      </View>
                    )}
                  </View>
                </View>
              );
            })}

            {/* USDT Balance Section for desktop */}
            {region !== INDIA && userInfo?.withdrawConfig?.pg?.some(pg => pg.value?.includes('magiclink')) && (
              <View style={[
                styles.walletContainer,
                {borderRightWidth: 0.75, flex: 1}
              ]}>
                <View style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  paddingVertical: 12,
                  paddingHorizontal: 16,
                  flex: 1,
                }}>
                  <View>
                    <View>
                      <View style={{flexDirection: 'row'}}>
                        <FormTextLabel
                          labelStyles={styles.creditAvaialableTxt}
                          label="USDT Balance"
                        />
                      </View>
                      <View style={{
                        flexDirection: 'row',
                        alignItems: 'center',
                      }}>
                        <Text style={styles.creditsAmt}>
                          {parseFloat(usdtBalance).toFixed(2)} {usdtSymbol}
                        </Text>
                      </View>
                      <View style={styles.withdrawableContainer}>
                        <Text style={styles.withdrawableText}>
                          You can convert your USDT into credits
                        </Text>
                      </View>
                    </View>
                  </View>
                </View>
              </View>
            )}
          </>
        )}
      </View>

      {/* Mobile buttons below summary */}
      {isMobile() && (
        <View style={styles.buttonContainer}>
          <View style={{flexDirection: 'row', justifyContent: 'space-between', gap: 12}}>
            <TouchableOpacity 
              style={styles.iconButton}
              onPress={() => onBtnPress('Add Funds')}
            >
              <View style={[styles.iconSquare, {backgroundColor: 'rgba(0, 0, 0, 0.05)'}]}>
                <Icon 
                  icon="si:add-duotone" 
                  width={28} 
                  height={28}
                  color={globalConfigurableData.primaryTextColor1}
                />
              </View>
              <Text style={styles.iconButtonText}>Add Funds</Text>
            </TouchableOpacity>

            <TouchableOpacity 
              style={styles.iconButton}
              onPress={() => onBtnPress('Withdraw')}
            >
              <View style={[styles.iconSquare, {backgroundColor: 'rgba(0, 0, 0, 0.05)'}]}>
                <Icon 
                  icon="si:credit-card-line" 
                  width={28} 
                  height={28}
                  color={globalConfigurableData.primaryTextColor1}
                />
              </View>
              <Text style={styles.iconButtonText}>Withdraw</Text>
            </TouchableOpacity>

            {/* Convert button temporarily disabled
            {region !== INDIA && (
              <TouchableOpacity 
                style={styles.iconButton}
                onPress={() => {}}
              >
                <View style={[styles.iconSquare, {backgroundColor: 'rgba(0, 0, 0, 0.05)'}]}>
                  <Icon 
                    icon="tabler:arrows-exchange" 
                    width={28} 
                    height={28}
                    color={globalConfigurableData.primaryTextColor1}
                  />
                </View>
                <Text style={styles.iconButtonText}>Convert</Text>
              </TouchableOpacity>
            )}
            */}

            {region === INDIA && (
              <TouchableOpacity 
                style={styles.iconButton}
                onPress={() => setShowFaq(true)}
              >
                <View style={[styles.iconSquare, {backgroundColor: 'rgba(0, 0, 0, 0.05)'}]}>
                  <Icon 
                    icon="material-symbols:help-outline" 
                    width={28} 
                    height={28}
                    color={globalConfigurableData.primaryTextColor1}
                  />
                </View>
                <Text style={styles.iconButtonText}>FAQ</Text>
              </TouchableOpacity>
            )}
          </View>
        </View>
      )}

      <WalletLastTxnStatus />

      {isShowHoldAmount && holdAmount > 0 && (
        <View
          style={{
            marginTop: 20,
            borderWidth: 0.75,
            borderColor: Color.borderColor,
            flexDirection: 'row',
            justifyContent: 'space-between',
            paddingHorizontal: 10,
            paddingVertical: 15,
            alignItems: 'center',
            borderRadius: 8,
          }}>
          <FastImage
            style={{
              width: 25,
              height: 25,
              marginRight: 5,
            }}
            source={globalConfigurableData?.info()}
          />
          <FormTextLabel
            labelStyles={styles.lockedText}
            label={'Locked amount: will be on hold for few hours'}
            rest={{holdAmount: holdAmount.toFixed(2)}}
          />
        </View>
      )}

      <HomeBanners screen="wallet" />
    </>
  );
};

export default WalletSummary;

const styles = StyleSheet.create({
  boxImgStyle: {
    width: 15,
    height: 15,
  },
  lockedNote: {
    backgroundColor: Colors.tradexBlue,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 10,
  },
  lockedText: {
    ...globalFontStyle.appFontSmallText,
    color: globalConfigurableData.primaryTextColor1,
    flex: 1,
  },
  txnStyle: {
    width: 15,
    height: 15,
    marginRight: 5,
  },
  statusTxt: {
    ...globalFontStyle.appFontSmallTextBold,
    flex: 1,
  },
  lcBlock: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 20,
    paddingVertical: 6,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    backgroundColor: 'rgba(251, 188, 5, 0.1)',
  },
  creditAvaialableTxt: {
    ...globalFontStyle.appFontSubText,
    color: globalConfigurableData.primaryTextColor1,
    paddingBottom: isMobile() ? 5 : 8,
  },
  creditsAmt: {
    ...globalFontStyle.appBlueHead,
    color: globalConfigurableData.primaryTextColor1,
  },
  walletDetailBox: {
    // borderRadius: 10,
    marginTop: 20,
    borderWidth: 0.75,
    borderColor: globalConfigurableData.borderColor,
    backgroundColor: GlobalScreens.Wallet.cardBgColor,
    borderRadius: 8,
    flexDirection: isMobile() ? 'column' : 'row',
  },
  walletDetailBox1: {
    backgroundColor: 'rgba(10, 87, 255, 0.05)',
    borderRadius: 10,
    paddingHorizontal: 20,
    paddingVertical: 10,
    marginTop: 22,
    zIndex: 10,
    flexDirection: 'row',
    justifyContent: 'space-between',
    flex: 1,
  },
  btnBlockSingle: {
    alignItems: 'center',
    borderRadius: 8,
    justifyContent: 'center',
    textAlign: 'center',
    paddingHorizontal: 15,
    borderColor: GlobalScreens.Wallet.walletSummaryBtnColor,
    borderWidth: 1,
    paddingVertical: 8,
  },
  investedContainer: {
    backgroundColor: 'green',
    borderWidth: 0.5,
    borderColor: 'rgba(0, 0, 0, 0.3)',
    flexDirection: 'row',
    borderRadius: 100,
    justifyContent: 'space-between',
    paddingHorizontal: 17,
    paddingVertical: 8,
    alignItems: 'center',
    marginBottom: 27,
  },
  walletContainer: {
    borderColor: globalConfigurableData.borderColor,
  },
  buttonContainer: {
    marginTop: 16,
    marginBottom: 16,
    paddingHorizontal: 16,
  },
  iconButton: {
    alignItems: 'center',
    flex: 1,
  },
  iconSquare: {
    width: 56,
    height: 56,
    borderRadius: 8,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 8,
  },
  iconButtonText: {
    ...globalFontStyle.appFontSmallText,
    color: globalConfigurableData.primaryTextColor1,
  },
  walletDetailBoxMobile: {
    flexDirection: 'column',
    paddingVertical: 16,
    borderWidth: 0,
    backgroundColor: 'transparent',
  },
  gridContainer: {
    width: '100%',
  },
  gridRow: {
    flexDirection: 'row',
    gap: 12,
    marginBottom: 12,
  },
  walletCardMobile: {
    borderWidth: 0.75,
    borderColor: globalConfigurableData.borderColor,
    backgroundColor: GlobalScreens.Wallet.cardBgColor,
    borderRadius: 8,
  },
  fullWidthCard: {
    width: '100%',
  },
  withdrawableContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 4,
  },
  withdrawableText: {
    ...globalFontStyle.appFontSmallText,
    color: globalConfigurableData.secondaryTextColor1,
    fontSize: 12,
  },
  whyButton: {
    marginLeft: 6,
    paddingHorizontal: 6,
    paddingVertical: 2,
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    borderRadius: 4,
  },
  whyText: {
    ...globalFontStyle.appFontSmallText,
    color: globalConfigurableData.primaryTextColor1,
    fontSize: 11,
  },
  playMoneyWrapper: {
    paddingVertical: 12,
    paddingHorizontal: 16,

  },
  playMoneyContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  divider: {
    height: 0.75,
    backgroundColor: globalConfigurableData.borderColor,
    marginHorizontal: 16,
  },
  breakupModalContent: {
    padding: 16,
  },
  breakupModalTitle: {
    ...globalFontStyle.appFontTitle,
    marginBottom: 10,
    color: globalConfigurableData.primaryTextColor1,
  },
  breakupModalSubtitle: {
    ...globalFontStyle.appFontSubText,
    marginBottom: 20,
    color: globalConfigurableData.secondaryTextColor1,
  },
  breakupTable: {
    width: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.02)',
    borderRadius: 12,
    overflow: 'hidden',
  },
  breakupRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 16,
    borderBottomWidth: 0.5,
    borderBottomColor: globalConfigurableData.borderColor,
  },
  breakupRowFirst: {
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
  },
  breakupRowLast: {
    borderBottomWidth: 0,
    borderBottomLeftRadius: 12,
    borderBottomRightRadius: 12,
  },
  breakupLabel: {
    ...globalFontStyle.appFontSubText,
    color: globalConfigurableData.primaryTextColor1,
  },
  breakupValue: {
    ...globalFontStyle.appFontSubText,
    color: globalConfigurableData.primaryTextColor1,
  },
});
